import { BaseAnalyticsService } from "@/modules/analytics/services/base-analytics.service";
import { DecodedToken } from "@/modules/common/context/auth/auth.context";
import { EnvironmentVariables } from "@/modules/common/types";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export class GoogleAnalyticsService extends BaseAnalyticsService {
  private readonly gaId = EnvironmentVariables.GOOGLE_ANALYTICS_ID?.toString();
  async init() {
    if (!window.gtag) {
      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`;
      script.async = true;
      document.head.appendChild(script);
      window.dataLayer = window.dataLayer || [];
      window.gtag = (...args) => window.dataLayer!.push(args);
      window.gtag("js", new Date());
      window.gtag("config", this.gaId);
    }
  }

  identify(user: DecodedToken) {
    window.gtag?.("set", { user_id: user["cognito:username"] });
  }

  setUserAttributes(attributes: Record<string, unknown>) {
    window.gtag?.("set", attributes);
  }

  pageView(event: string, payload?: Record<string, unknown>) {
    window.gtag?.("config", event, payload);
  }

  track(event: string, payload: Record<string, unknown> = {}) {
    window.gtag?.("event", event, payload);
  }

  unidentify() {
    window.gtag?.("set", { user_id: null });
  }
}
